import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../auth.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { toSignal } from '@angular/core/rxjs-interop';
import User from '../user';

@Component({
  selector: 'app-session-management',
  templateUrl: './session-management.component.html',
  styleUrls: ['./session-management.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem],
})
export class SessionManagementComponent {
  private readonly authService = inject(AuthService);
  protected readonly user = toSignal(this.authService.getCurrentUser(), {
    initialValue: User.anonymousUser(),
  });

  logout(): void {
    void this.authService.logout();
  }
}
